/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { ISite } from '../../types';
import { Site } from './types';

const initialState: ISite | null = null;

export const siteReducer: Reducer<ISite | null> = (state = initialState, action) => {
  switch (action.type) {
    case Site.GET_SITE_SUCCESS:
    case Site.UPDATE_GRACE_PERIOD_POLICY_SUCCESS:
    case Site.UPDATE_BUSINESS_DAY_START_SUCCESS:
    case Site.UPDATE_CREDIT_CARD_FEE_SUCCESS:
    case Site.UPDATE_WITHHOLDINGS_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case Site.GET_SITE_BALANCE_SUCCESS: {
      return {
        ...state,
        accountBalance: action.payload.current,
      };
    }
    case Site.CLEAR_SITE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
